import { defineStore } from 'pinia'

interface AttemptsTableAttempt {
  position: number,
  value: string,
  highlight: boolean
}

interface AttemptsTablePlayerInfo {
  country: string,
  countryString: string,
  name: string
}

interface AttemptsTableState {
  attempts: AttemptsTableAttempt[],
  playerInfo: AttemptsTablePlayerInfo,
  visible: boolean,
  position: number
}

const initialState = (): AttemptsTableState => ({
  visible: false,
  position: 1,
  attempts: [
    {
      position: 1,
      value: '',
      highlight: false
    },
    {
      position: 2,
      value: '',
      highlight: false
    },
    {
      position: 3,
      value: '',
      highlight: false
    },
    {
      position: 4,
      value: '',
      highlight: false
    },
    {
      position: 5,
      value: '',
      highlight: false
    },
    {
      position: 6,
      value: '',
      highlight: false
    }
  ],
  playerInfo: {
    country: '',
    countryString: '',
    name: ''
  }
})

export const attemptsTableState = defineStore('attemptsTableState', {
  state: initialState,
})
